import * as React from "react";
const SvgFiRrStateCountry = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-state-country_svg__a)">
      <path
        fill="#062147"
        d="M23 8V3.967c.562-.082 1-.545 1-1.13 0-.5-.32-.944-.795-1.103L18.368.122a1.16 1.16 0 0 0-.735 0l-4.838 1.613A1.16 1.16 0 0 0 12 2.838c0 .584.438 1.047 1 1.13V8a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2zm-2 0h-2V4h2zm-6-4h2v4h-2zm-3 12.837c0-.5-.32-.944-.795-1.102L6.367 14.12a1.16 1.16 0 0 0-.735 0L.794 15.736a1.16 1.16 0 0 0-.795 1.102c0 .585.438 1.047 1 1.13v4.034a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2v-4.033c.562-.082 1-.546 1-1.13zM3 18h2v4H3zm4 4v-4h2v4zm16.707-.207a.999.999 0 1 1-1.414 1.413L20.086 21H16c-1.103 0-2-.898-2-2v-3.54l-6.302-5.401A2 2 0 0 1 7 8.539V5H3.414A1.99 1.99 0 0 1 2 4.415L.293 2.707a.999.999 0 1 1 1.414-1.414L3.414 3H7c1.103 0 2 .897 2 2v3.54l6.301 5.4A2 2 0 0 1 16 15.46V19h4.086c.526 0 1.042.213 1.414.585z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-state-country_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStateCountry;
